module.exports = __webpack_public_path__ + "static/media/shouldigoout.8918ced6.gif";